<template>
  <v-app id="app">
    <bionic-metrics-loading-bar/>
    <router-view :key='reload'/>
    <bionic-metrics-snackbar/>
    <bionic-metrics-error-snackbar/>
    <bionic-metrics-update-snackbar/>
    <bionic-metrics-alert/>
    <bionic-metrics-confirm/>
    <bionic-metrics-choose/>
  </v-app>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import SystemBus from './services/systemBus.service';
import UserBus from './services/userBus.service';
import GitBus from './services/gitBus.service';
import BionicMetricsLoadingBar from './components/LoadingBar';
import BionicMetricsSnackbar from './components/Snackbar';
import BionicMetricsErrorSnackbar from './components/ErrorSnackbar';
import BionicMetricsAlert from './components/Alert';
import BionicMetricsConfirm from './components/Confirm';
import BionicMetricsChoose from './components/Choose';
import BionicMetricsUpdateSnackbar from './components/UpdateSnackbar';
import Events from './services/events.service';

export default {
  async created() {
    window.addEventListener('beforeunload', this.checkForUnsavedChanges);
    window.addEventListener('keydown', this.keydown);
    try {
      Events.$on('signin', this.init);
      await this.getUser();
      if (!this.user) return; // not authenticated, nothing to init
      await this.init();
    } catch (e) {
      console.error(e);
    }
  },
  async beforeDestroy() {
    window.removeEventListener('beforeunload', this.checkForUnsavedChanges);
    window.removeEventListener('keydown', this.keydown);
    await UserBus.destroy();
    await GitBus.destroy();
  },
  components: {
    BionicMetricsUpdateSnackbar,
    BionicMetricsChoose,
    BionicMetricsConfirm,
    BionicMetricsAlert,
    BionicMetricsLoadingBar,
    BionicMetricsErrorSnackbar,
    BionicMetricsSnackbar
  },
  name: 'app',
  computed: {
    ...mapGetters({
      user: 'getUser',
      savingStatus: 'getSavingStatus',
      reload: 'getReload'
    })
  },
  methods: {
    async init() {
      // only get account and setup user bus if we're signed in
      if (this.user.theme === 'dark') this.$vuetify.theme.dark = true;
      await this.getAccount(this.user);
      await SystemBus.setup();
      await UserBus.setup();
      await GitBus.setup();
    },
    keydown(e) {
      const {key, srcElement} = e;
      if (srcElement !== document.body) return;
      if (key === '/') {
        this.setFocus();
        e.preventDefault();
      }
    },
    checkForUnsavedChanges(event) {
      if (this.savingStatus === 'SAVING') {
        const confirmationMessage = 'Unsaved Changes';
        event.returnValue = confirmationMessage; //Gecko + IE
        return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
      }
    },
    ...mapActions({
      getUser: 'getUser',
      getAccount: 'getAccount'
    }),
    ...mapMutations({
      setFocus: 'setFocus'
    })
  }
};
</script>

<style lang='scss'>
html, body {
  overflow-x: hidden
}

.front-background #app {
  background: linear-gradient(-121deg, transparent 94%, rgba(8, 37, 67, 1) 0),
  linear-gradient(-107deg, transparent 92%, rgba(8, 37, 67, .45) 0),
  linear-gradient(-99deg, transparent 90%, rgba(8, 37, 67, .30) 0),
  linear-gradient(0deg, #fafafa, #FFFFFF);
  background-repeat: no-repeat;

  margin: 0;
  width: 100%;
  min-height: 100%;
  height: 100%;
  padding: 0;
}

.flush-right {
  margin-right: 0;
}

.spaced-divider {
  margin-bottom: 30px;
}

.spaced {
  margin-bottom: 30px;
}

.todo {
  border: 5px solid mediumpurple;
  width: 100%;
  height: 100%;
}

.full-width {
  width: 100%;
}

.clickable {
  cursor: pointer;
}

a {
  text-decoration: none;
}

/* Vuetify Tweaks  */
.align-toolbar-buttons {
  .v-toolbar__content {
    padding-left: 4px !important;
  }
}

.theme--light {
  .code {
    font-family: monospace;
    background: #f4f4f4;
    border: 1px solid #ddd;
    border-left: 3px solid #455A64;
    color: #666;
    page-break-inside: avoid;
    font-size: 15px;
    line-height: 1.6;
    margin-bottom: 1.6em;
    max-width: 100%;
    overflow: auto;
    padding: 1em 1.5em;
    display: block;
    word-wrap: break-word;
  }

  .error-code {
    font-family: monospace;
    background: #f4f4f4;
    border: 1px solid #ddd;
    border-left: 3px solid #d84315;
    color: #666;
    page-break-inside: avoid;
    font-size: 12px;
    line-height: 1;
    margin-bottom: 1em;
    max-width: 100%;
    overflow: auto;
    padding: 1em 1.5em;
    display: block;
    word-wrap: break-word;
  }

}

.theme--dark {
  .code {
    font-family: monospace;
    background: #2E2E2E;
    border: 1px solid #555555;
    border-left: 3px solid #8abcf1;
    color: #cccccc;
    page-break-inside: avoid;
    font-size: 15px;
    line-height: 1.6;
    margin-bottom: 1.6em;
    max-width: 100%;
    overflow: auto;
    padding: 1em 1.5em;
    display: block;
    word-wrap: break-word;
  }

  .error-code {
    font-family: monospace;
    background: #2E2E2E;
    border: 1px solid #555555;
    border-left: 3px solid #d84315;
    color: #cccccc;
    page-break-inside: avoid;
    font-size: 12px;
    line-height: 1;
    margin-bottom: 1em;
    max-width: 100%;
    overflow: auto;
    padding: 1em 1.5em;
    display: block;
    word-wrap: break-word;
  }
}


</style>
